import { memo } from 'react';

export default memo(SpinnerSan);

function SpinnerSan({ progress, size }: { progress?: number; size: number }) {
  const progressWidth =
    progress !== undefined ?
      progress < 100 ?
        Math.round((size * progress) / 100)
      : size
    : 0;
  const progressBarHeight = size / 32;
  const progressBarBottom = size / 18;

  const viewBoxSize = 180;
  const strokeWidth = 8;
  const radius = (viewBoxSize - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      {/* Static Logo Background */}
      <svg
        viewBox="0 0 180 180"
        className="absolute"
        style={{ width: size * 0.85, height: size * 0.85 }}
      >
        <g fill="currentColor" className="text-foreground opacity-20">
          <path d="m74.102 113.08c1.8195 1.099 3.9574 2.061 6.4137 2.885 2.5473 0.733 5.1401 1.1 7.7783 1.1 3.0022 0 5.5495-0.733 7.6419-2.199 2.0924-1.557 3.1386-4.03 3.1386-7.42 0-2.839-0.6368-5.175-1.9104-7.007-1.2737-1.8323-2.9112-3.4812-4.9127-4.9468-1.9104-1.4657-4.0029-2.7939-6.2772-3.9848-2.2744-1.2824-4.4123-2.7938-6.4138-4.5343-1.9104-1.7405-3.5025-3.8015-4.7761-6.1832-1.2737-2.3817-1.9105-5.4046-1.9105-9.0687 0-5.8626 1.5466-10.26 4.6397-13.191 3.1841-3.0228 7.6419-4.5343 13.373-4.5343 3.73 0 6.9596 0.3664 9.6889 1.0992 2.729 0.6413 5.094 1.5573 7.096 2.7481l-2.593 8.2443c-1.728-0.916-3.73-1.6489-6.0042-2.1985-2.2743-0.6412-4.5942-0.9618-6.9595-0.9618-3.2751 0-5.686 0.687-7.2325 2.0611-1.4556 1.374-2.1834 3.5267-2.1834 6.458 0 2.2901 0.6368 4.2595 1.9104 5.9084 1.2737 1.5572 2.8657 3.0229 4.7762 4.3969 2.0015 1.2825 4.1394 2.6107 6.4137 3.9848 2.2744 1.374 4.3673 3.0229 6.2773 4.9465 2.001 1.8321 3.639 4.0764 4.913 6.7328 1.273 2.5649 1.91 5.8172 1.91 9.7562 0 2.564-0.409 4.992-1.228 7.282s-2.092 4.305-3.821 6.046c-1.638 1.649-3.73 2.977-6.2773 3.985-2.4563 1.007-5.3675 1.511-8.7335 1.511-4.0029 0-7.46-0.412-10.371-1.237-2.9112-0.732-5.3676-1.74-7.369-3.023l3.0022-8.656z" />
          <ellipse cx="45.45" cy="89.1" rx="7.65" ry="8.1" />
          <circle cx="133.2" cy="89.1" r="8.1" />
        </g>
      </svg>

      {/* Spinning Gradient Ring */}
      {progress === undefined && (
        <svg
          viewBox="0 0 180 180"
          className="absolute animate-spin"
          style={{
            width: size,
            height: size,
            animationDuration: '1.2s',
          }}
        >
          <defs>
            <linearGradient
              id="spinner-gradient"
              x1="180"
              y1="90"
              x2="90"
              y2="180"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
              <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
            </linearGradient>
          </defs>
          <circle
            cx={viewBoxSize / 2}
            cy={viewBoxSize / 2}
            r={radius}
            fill="none"
            stroke="url(#spinner-gradient)"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference * 0.75}
            strokeDashoffset={circumference * 0.25}
          />
        </svg>
      )}

      {/* Progress Bar */}
      {typeof progress === 'number' && (
        <div
          className="absolute rounded"
          style={{
            bottom: progressBarBottom,
            width: size,
            height: progressBarHeight,
            background: '#f5f7f9',
          }}
        >
          <div
            className="absolute bottom-0 rounded"
            style={{
              minWidth: progressWidth,
              height: progressBarHeight,
              background: '#1e2028',
            }}
          />
        </div>
      )}
    </div>
  );
}
